<template>
	<v-dialog v-model="dialog" width="900">
		<template v-slot:activator="{ on }">
			<a v-on="on" class="person-link link">{{ person.name }}</a>
		</template>

		<v-card class="people-dialog-card">
			<v-row>
				<v-col cols="12" lg="3" class="text-center">
					<img :src="person.photo" :alt="person.name" class="people-dialog-image" />
					<v-btn
						v-if="person.website"
						text
						color="rgb(153, 27, 30)"
						target="_blank"
						:href="person.website"
					>Personal Website</v-btn>
				</v-col>
				<v-col cols="12" lg="9">
					<h1 class="person-modal-name">{{ person.name }}</h1>
					<h4 class="person-modal-title">{{ title }}</h4>
					<p>{{ person.description }}</p>
					<div v-if="person.projects">
						<br />
						<h3>Projects:</h3>
						<ul>
							<li v-for="proj in person.projects" :key="proj">{{ proj }}</li>
						</ul>
					</div>
				</v-col>
			</v-row>

			<i class="mdi mdi-open-in-new" @click="goToDesc" />
			<i class="mdi mdi-close people-dialog-close" @click="dialog = false" />
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		person: Object,
		title: String
	},
	data() {
		return {
			dialog: false
		};
	},
	methods: {
		goToDesc() {
			this.$router.push({
				name: "PeopleDetail",
				query: {
					id: this.person.id
				}
			});
		}
	}
};
</script>

<style lang="scss">
.people-image {
	max-width: 100%;
	width: 100%;
	max-height: 173.5px;
	height: 173.5px;
}

.people-card {
	cursor: pointer;
	transition: transform 1s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.people i {
	font-size: 25px;
}

.people-card:hover {
	transform: scale(1.05);
}

.people-dialog-close {
	color: rgb(153, 27, 30);
	font-size: 30px;
	position: absolute;
	right: 10px;
	top: 5px;
	cursor: pointer;
}

.person-link {
	cursor: pointer;
	color: rgb(153, 27, 30);
	padding-bottom: 10px;
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.people-list {
		.col-12 {
			.person-link {
				font-size: 20px;
				padding-bottom: 20px !important;
			}
		}
	}
}
</style>